/* 我的-钱包-账单详情  */
<template>
  <div class="bill-detail">
    <!-- 头部 -->
    <headerTop title="账单详情"></headerTop>
    <!-- 内容 -->
    <div class="content">
      <div class="row" v-for="(item, index) in dataList" :key="index">
        <div class="user">
          <div class="phone">
            <img
              src="data:image/png;base64,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"
              alt=""
            >
            {{ `${item.phone}`.substring(0, 3) + '****' + `${item.phone}`.substring(7, 11) }}
          </div>
          <div class="date">{{item.payTime.substring(0, 19)}}</div>
        </div>
        <div class="bill-content">
          <div class="title">{{item.productName}}</div>
          <p>订单编号：{{item.tradeNo}}</p>
          <p>
            <label>商品单价：¥{{(item.unitPrice * 0.01).toFixed(2)}}</label>
            <span>X{{item.buyNum}}</span>
          </p>
          <div class="commission">
            <div class="pay">付款：¥{{(item.unitPrice * item.buyNum * 0.01).toFixed(2)}}</div>
            <div :class="item.status == 9?'refund':'earn'" >
              <span>{{ item.bill_price_view }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import javaApi from "@/api/javaApi";

export default {
  data() {
    return {
      dataList: [],
      businessId: this.$route.query.businessId,
      billCategory: this.$route.query.billCategory,
      createTime: this.$route.query.createTime,
      price: this.$route.query.price
    };
  },
  computed: {},
  async mounted() {
    const res = await javaApi.commissionDetail({
      business_id: this.businessId,
      bill_category: this.billCategory,
      create_time: this.createTime,
      price: this.price
    });
    this.dataList = res || [];
  },
  methods: {},
  components: {
    headerTop
  }
};
</script>

<style lang="less" scoped>
.bill-detail {
  .row {
    margin: 5px 15px 0;
    border-bottom: 1px solid #eeeeee;
    &:nth-last-child(1) {
      border: none;
    }
    .user {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 30px;
      .phone {
        font-size: 12px;
        color: #333333;
        img {
          width: 20px;
          height: 20px;
          margin-left: 5px;
        }
      }
      .date {
        font-size: 12px;
        color: #999999;
      }
    }
    .bill-content {
      .title {
        font-size: 14px;
        color: #1d1d1d;
        line-height: 1.5;
      }
      p {
        position: relative;
        font-size: 12px;
        color: #666666;
        line-height: 2;
        span {
          position: absolute;
          right: 0;
        }
      }
      .commission {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 45px;
        .pay {
          font-size: 14px;
          color: #1d1d1d;
        }
        .earn {
          font-size: 14px;
          color: #ea2c2c;
          span {
            font-size: 18px;
          }
        }
        .refund{
          font-size: 14px;
          color: #37a851;
          span {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
